import React, { useState, useContext, useEffect, Fragment } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@mui/styles";
import {
  AttachMoney,
  Search,
  RadioButtonUnchecked,
  CheckCircle,
  ArrowRightAlt,
  RemoveOutlined,
} from "@mui/icons-material";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import clsx from "clsx";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import axios from "axios";
import { TextField, Box, Grid, Alert, Typography, Button } from "@mui/material";
import Moment from "moment";

import ViewstrasactionsAdmin from "views/dialog/ViewstrasactionsAdmin";

import loaderGif from "assets/img/loading.gif";
import noDataImg from "assets/img/undraw_House_searching_re_stk8.png";

import {
  blackColor,
  cardBodyStyle,
  ButtonTableGrid1,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

const infoStyle = {
  color: "#1d1d1b",
  fontSize: 10,
  fontWeight: "bold",
  margin: "3px 0",
  borderBottom: "1px solid #f2f2f2",
  paddingLeft: 2,
  padding: "2px 5px 2px 15px",
};

export default function TransactionsAdmin() {
  const classes = useStyles();

  const [idRow, setIdRow] = useState("");
  const [ToGoModule, setToGoModule] = useState(false);
  const [rows, setRows] = useState([]);
  const [openViewsTransactions, setOpenViewsTransactions] = useState(false);
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [searchText, setSearchText] = useState("");
  const [rowsResponse, setRowsResponse] = useState([]);

  const { urlServices, UserAuth } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const [state] = useState({
    columns: [
      {
        headerName: "COD.",
        field: "code",
        width: 60,
        headerAlign: "center",
        align: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        renderCell: (params) => {
          return (
            <Alert severity="info" icon={false}>
              <b style={{ fontSize: 10 }}>{params.value} </b>
            </Alert>
          );
        },
        sortable: false,
        filtering: false,
        hideable: false,
      },
      ...(UserAuth.profile_id === 2
        ? [
            {
              headerName: "Gestor",
              field: "user",
              flex: 1,
              headerAlign: "center",
              headerClassName: "super-app-theme--header",
              cellClassName: (params) => {
                return clsx("super-app", {
                  celAll: params.value,
                });
              },
              renderCell: (params) => {
                return (
                  <div style={{ whiteSpace: "normal" }}>
                    {renderProfile(params.row)}
                  </div>
                );
              },
              sortable: false,
              filtering: false,
              hideable: false,
            },
          ]
        : []),
      {
        headerName: "Cliente",
        field: "client.allNames",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return <b style={{ fontSize: 12 }}>{params.row.client.allNames} </b>;
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        flex: 1,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Creación",
        field: "createdAt",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return <span>{Moment(params.value).format("DD-MM-YYYY")} </span>;
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 110,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        field: "action1",
        headerName: "----",
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        width: 70,
        align: "center",
        renderCell: (params) => (
          <ButtonTableGrid1
            onClick={openViewsTransactionsValue(params)}
            style={{ margin: "12px 0" }}
          >
            Ver
          </ButtonTableGrid1>
        ),
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "TERMINOS",
        field: "status",
        headerAlign: "center",
        width: 90,
        align: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          const cardRegister =
            Array.isArray(params.row.client?.cardCollection) &&
            params.row.client?.cardCollection.length > 0;
          return (
            <>
              {params.row.acceptTerms || cardRegister ? (
                <CheckCircle
                  sx={{
                    fontSize: 18,
                    marginLeft: 1,
                    color: "green",
                    verticalAlign: "middle",
                  }}
                />
              ) : (
                <RadioButtonUnchecked
                  sx={{
                    fontSize: 18,
                    marginLeft: 1,
                    color: "red",
                    verticalAlign: "middle",
                  }}
                />
              )}
            </>
          );
        },
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "PAGO",
        field: "status1",
        headerAlign: "center",
        width: 90,
        align: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          const typePayCR =
            params.row.productsJson[0].typePay === "CR" ? true : false;
          return (
            <>
              {params.row.paymentTransactions.some(
                (transaction) => transaction.status === 1
              ) ? (
                <CheckCircle
                  sx={{
                    fontSize: 18,
                    color: "green",
                    verticalAlign: "middle",
                  }}
                />
              ) : typePayCR ? (
                <RemoveOutlined />
              ) : (
                <RadioButtonUnchecked
                  sx={{
                    fontSize: 18,
                    marginLeft: 1,
                    color: "red",
                    verticalAlign: "middle",
                  }}
                />
              )}
            </>
          );
        },
        sortable: false,
        filtering: false,
        hideable: false,
      },
    ],
  });

  const renderProfile = (row) => (
    <>
      <Typography sx={infoStyle} style={{ fontSize: 12 }}>
        {row.user.allNames}
      </Typography>
      <Typography sx={infoStyle} style={{ fontWeight: 500 }}>
        ({row.user.profile.name})
      </Typography>
    </>
  );

  useEffect(() => {
    RefreshTable();
  }, []);

  // Función para eliminar acentos de una cadena de texto
  const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const handleSearchChange = (event) => {
    const value = event.target.value; // Obtener el valor del input
    setSearchText(value); // Actualizar el estado del texto de búsqueda

    // Filtrar los datos según el valor de búsqueda
    if (value.trim() !== "") {
      const resultSearch = rowsResponse.filter(
        (item) =>
          removeAccents(item.user.allNames.toLowerCase()).includes(
            removeAccents(value.toLowerCase())
          ) ||
          removeAccents(item.client.allNames.toLowerCase()).includes(
            removeAccents(value.toLowerCase())
          ) ||
          item.code.toString().includes(value)
      );
      setRows(resultSearch);
    } else {
      setRows(rowsResponse); // Restaurar los datos originales si no hay búsqueda
    }
  };

  const RefreshTable = async () => {
    setSearchText("");
    setLoader(true);

    const handleResponseData = (data) => {
      return data.map((item) => ({
        ...item,
        productsJson: parseJsonArray(item.productsJson),
        dependentsJson: parseJsonArray(item.dependentsJson),
      }));
    };

    const handleErrors = (error) => {
      if (error.response) {
        const { status } = error.response;
        if (status === 401) {
          setMensageSystem(
            "La sesión ha expirado, vuelva a iniciar sesión ..."
          );
          setError(true);
          setTimeout(() => {
            localStorage.clear();
            setReturnLogin(true);
          }, 4000);
        } else if (status === 500) {
          setRows([]);
          setMensageSystem("Error en la consulta con el servidor.");
          setError(true);
        } else {
          console.error("Error en la solicitud:", error);
          setRows([]);
          setMensageSystem("Error al realizar la solicitud.");
          setError(true);
        }
      } else {
        console.error("Error en la solicitud:", error);
        setRows([]);
        setMensageSystem("Error al realizar la solicitud.");
        setError(true);
      }
    };

    try {
      const { data, status } = await axios.get(
        `${urlServices}clients-transaction/list/company`,
        {
          headers: { Authorization: `Bearer ${keyAuthorization}` },
        }
      );

      if (status === 200) {
        const transformedRows = handleResponseData(data);

        // 1. Filtrar transacciones que no tengan al menos un pago con status 1
        const dataFilterPay = transformedRows.filter((item) => {
          // Verificamos que ninguna transacción tenga status 1
          return item.paymentTransactions.every(
            (transaction) => transaction.status !== 1
          );
        });

        const responseDataFinal = dataFilterPay.filter(
          (client) => client.cashPaymentTransactions.length === 0
        );

        setRows(responseDataFinal);
        setRowsResponse(responseDataFinal);
      }
    } catch (error) {
      handleErrors(error);
    } finally {
      setLoader(false);
    }
  };

  // Función para parsear cadenas JSON y asegurar que sean arrays
  const parseJsonArray = (jsonString) => {
    try {
      const parsed = JSON.parse(jsonString);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return [];
    }
  };

  const openViewsTransactionsValue = (data) => () => {
    setIdRow(data);
    setOpenViewsTransactions(true);
  };

  const handleCloseViewsDependents = () => setOpenViewsTransactions(false);

  const goToModule = () => () => {
    setToGoModule(true);
  };

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  if (ToGoModule) {
    localStorage.setItem("controllerRouter", "/customers/transactions");
    return <Redirect to="/customers/transactions" />;
  }

  return (
    <Card variant="outlined">
      <CardBody>
        {error ? <Alert severity="error">{mensageSystem}</Alert> : ""}
        {loader ? (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <center>
                <img
                  alt="loaderGif"
                  src={loaderGif}
                  style={{ width: 60, margin: "20% 0" }}
                />
              </center>
            </Grid>
          </Grid>
        ) : (
          <Fragment>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={8}>
                <div
                  className={classes.cardTitleBlack}
                  style={{ fontSize: 22 }}
                >
                  <AttachMoney className={classes.iconFilter} /> Transacciones
                  pendientes{" "}
                </div>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Button
                  sx={{ color: blackColor, float: "right" }}
                  size="small"
                  endIcon={<ArrowRightAlt sx={{ fontSize: 14 }} />}
                  onClick={goToModule()}
                >
                  Ir al módulo
                </Button>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div style={{ float: "right" }}>
                  <TextField
                    variant="outlined"
                    value={searchText}
                    onChange={handleSearchChange}
                    sx={{ mb: 1 }}
                    size="small"
                    InputProps={{
                      startAdornment: (
                        <Search
                          position="start"
                          style={{
                            color: "gray",
                            fontSize: 22,
                            marginRight: 10,
                          }}
                        />
                      ),
                    }}
                    placeholder="Buscar"
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container>
              {rows.length > 0 ? (
                <Grid item xs={12} sm={12}>
                  <Box
                    sx={{
                      "& .super-app.celAll": {
                        fontSize: 12,
                        //backgroundColor: 'rgba(255, 7, 0, 0.55)',
                      },
                      "& .super-app.celActions": {
                        backgroundColor: "rgb(242, 242, 242)",
                      },
                      "& .super-app-theme--header": {
                        backgroundColor: "rgb(242, 242, 242)",
                      },
                      marginTop: 2,
                    }}
                  >
                    <DataGrid
                      rows={rows}
                      columns={state.columns}
                      loading={loader}
                      initialState={{
                        pagination: {
                          paginationModel: { page: 0, pageSize: 10 },
                        },
                      }}
                      pageSizeOptions={[5, 10, 20, 50]}
                      disableRowSelectionOnClick={true}
                      checkboxSelection={false}
                      sx={{
                        [`& .${gridClasses.cell}`]: {
                          display: "flex",
                          alignItems: "center", // Alineación vertical
                          // justifyContent: 'center', // Alineación horizontal
                          wordWrap: "break-word !important",
                          whiteSpace: "normal !important",
                        },
                        /* [`& .${gridClasses.columnHeaderTitle}`]: {
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                },*/
                      }}
                      getRowHeight={() => "auto"}
                      // autoHeights
                      autoWidth
                    />
                  </Box>
                </Grid>
              ) : (
                <Grid item xs={12} sm={12}>
                  <center>
                    <img
                      alt="loaderGif"
                      src={noDataImg}
                      style={{ width: 300, marginTop: 50 }}
                    />
                    <br></br>
                    <b style={{ fontSize: 18, margin: "5px 0 70px 0" }}>
                      No hay registros para mostrar
                    </b>
                  </center>
                </Grid>
              )}
            </Grid>
          </Fragment>
        )}
      </CardBody>
      {openViewsTransactions && (
        <ViewstrasactionsAdmin
          open={openViewsTransactions}
          exit={handleCloseViewsDependents}
          callBackRefresh={RefreshTable}
          id={idRow}
        />
      )}
    </Card>
  );
}
